import { Params, ParamMap } from '@angular/router';
import { dateParamFormat } from 'src/shared/constants';
import * as moment from 'moment';

const STARTING_SUNDAY_KEY = 'sd';

export const toStartingSundayParams = (args: {
	startingSunday?: string | moment.Moment;
}): Params =>
	args.startingSunday
		? {
				[STARTING_SUNDAY_KEY]: args.startingSunday
					? moment(args.startingSunday, dateParamFormat).format(
							dateParamFormat
					  )
					: undefined,
		  }
		: undefined;

export const toStartingSundayListArgs = (
	params: ParamMap
): { startingSunday?: string } =>
	params.has(STARTING_SUNDAY_KEY)
		? {
				startingSunday: params.get(STARTING_SUNDAY_KEY),
		  }
		: undefined;
